import Alert from '@storeblocks/alert-rebrand';
import { WrapLgMarginBottom } from 'App/global-style';
import { useFormStatus } from 'Forms/forms.hooks';
import React from 'react';
import { isDefined } from 'Utils/type.utils';
import {
  getCancelTravelAlertDescription,
  getCancelTravelAlertTitle,
} from '../cancelTravelForm.helpers';
import { CancelTravelFormValues } from '../cancelTravelForm.types';

interface CancelTravelFormAlertsProps {
  formValues: CancelTravelFormValues;
  isSubmitting: boolean;
}

export const CancelTravelFormAlerts = ({
  formValues,
  isSubmitting,
}: CancelTravelFormAlertsProps): React.ReactElement | null => {
  const { cancelReason } = formValues;
  const { submitSuccess } = useFormStatus();

  if (!isDefined(cancelReason) || isSubmitting || submitSuccess) {
    return null;
  }

  return (
    <WrapLgMarginBottom>
      <Alert
        fluid
        variant="info"
        title={getCancelTravelAlertTitle(cancelReason)}
        description={getCancelTravelAlertDescription(cancelReason)}
      />
    </WrapLgMarginBottom>
  );
};
